module.exports = __webpack_public_path__ + "static/images/styles/images/reserves/journal/inspiration.37b56959.png";


//////////////////
// WEBPACK FOOTER
// ./styles/images/reserves/journal/inspiration.png
// module id = 3742
// module chunks = 11